import { Box, IconButton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { insuranceSelector } from '../../../model';
import { useSelector } from 'react-redux';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import GetAppIcon from '@mui/icons-material/GetApp';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';
import { DateFormats } from '../../../../../../constants/common';

interface Props {
  onRemove: () => {};
}

export const UploadedFileRow = ({ onRemove }: Props) => {
  const classes = useStyles();

  const insuranceBroker = useSelector(insuranceSelector.insuranceBroker)!;
  const insuranceCertificate = useSelector(insuranceSelector.insuranceCertificate)!;
  const insuranceVerificationTask = useSelector(insuranceSelector.insuranceVerificationTask)!;

  return (
    <>
      <Box className={classes.uploadedFile}>
        <Box className={classes.uploadedFileSideBox}>
          <InsertDriveFileIcon className={classes.fileIcon} />
          <Typography variant="body2">{insuranceCertificate.docName}</Typography>
        </Box>
        <Box className={classes.uploadedFileSideBox}>
          <IconButton href={insuranceCertificate.source!} target="_blank" size="small" className={classes.borderedIcon}>
            <GetAppIcon color="primary" fontSize="small" />
          </IconButton>
          <IconButton
            href={`/document/${insuranceCertificate.documentId}`}
            target="_blank"
            size="small"
            className={classes.borderedIcon}
          >
            <VisibilityIcon color="primary" fontSize="small" />
          </IconButton>
          <IconButton onClick={onRemove} size="small" className={classes.deleteFileIcon}>
            <DeleteOutlineIcon />
          </IconButton>
        </Box>
      </Box>
      <Box className={classes.uploadedBy}>
        <Typography variant="body2">
          Uploaded by:{' '}
          {insuranceVerificationTask?.completionData
            ? insuranceVerificationTask.completionData.name
            : insuranceCertificate.createdBy}
        </Typography>
        <Typography variant="body2">
          {moment(insuranceCertificate.createdDateTime).format(DateFormats.TimeWithShortDate)}
        </Typography>
      </Box>
    </>
  );
};

const useStyles = makeStyles({
  uploadedFile: {
    padding: '8px 16px',
    backgroundColor: '#EEF0FA',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:not(:last-child)': {
      marginBottom: 8,
    },
  },
  uploadedFileSideBox: {
    display: 'flex',
    alignItems: 'center',
  },
  borderedIcon: {
    border: '1px solid #0c84fc',
    borderRadius: '20%',
    marginRight: 8,
  },
  fileIcon: {
    color: '#9FA8DA',
    marginRight: '4px',
  },
  deleteFileIcon: {
    '&.MuiButtonBase-root': {
      color: '#FF5252',
      marginLeft: '4px',
    },
  },
  uploadedBy: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
